import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import CornMasaFlourProduct from 'models/CornMasaFlourProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { cookingTypeOptions, packagingInitialState } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotNumericDecimal } from 'context/Utilities'

const CornMasaFlourPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, CookingType, Size } = current
      setPackaging({
        category,
        subCategory,
        CookingType,
        Size,
      })
    } else if (!updating) {
      setCurrent(CornMasaFlourProduct)
    }
    console.log(
      'current inside useEffect for CornMasaFlourPackage: ' +
        JSON.stringify(current)
    )
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (current) {
      setPackaging({ ...packaging, ...current })
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs="6">
        <FormGroup>
          <p>
            <strong>Cooking Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={cookingTypeOptions}
            name="CookingType"
            control={methods.control}
            rules={{ required: '⚠ Cooking Type is required.' }}
            placeholder="Select Cooking Type"
            onChange={([selected]) => {
              setSelect(selected, 'CookingType')
              return selected
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="CookingType"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="Size"
            placeholder={'12 - 48 ounces'}
            control={methods.control}
            rules={{
              required: '⚠ Size is required.',
              validate: Size => Size >= 12 && Size <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default CornMasaFlourPackage
